
define(
	'MHI.BasicEnhancements.CustomCategoryFields'
,   [
		'Facets.Browse.CategoryHeading.View',
		'MHI.BasicEnhancements.CustomCategoryFields.SS2Model'
	]
,   function (
		FacetsBrowseCategoryHeadingView,
		CustomCategoryFieldsSS2Model
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{

			_.extend(FacetsBrowseCategoryHeadingView.prototype, {
				initialize: _.wrap(FacetsBrowseCategoryHeadingView.prototype.initialize, function (initialize) {
					initialize.apply(this, _.toArray(arguments).slice(1));
					var self = this;
					
					
					var customFieldModel = new CustomCategoryFieldsSS2Model();
					customFieldModel.fetch({
							async: true,
							data:{
								categoryid: self.model.get('internalid')
							}
						}).done(function(result) {
							
							self.customFields = result;
							self.render();
							
						});

				}),
				getContext: _.wrap(FacetsBrowseCategoryHeadingView.prototype.getContext, function (getContext) {
					var context = getContext.apply(this, _.toArray(arguments).slice(1));
					
					context.customFields = this.customFields || {};
					

					return context;
				})
			})
		}
	};
});
